import React from "react";
import { DropdownItem } from "reactstrap";
import {
  isOwnStoreProject,
  normalizeStoreUserId,
  partitionStoreProjectsByOwner,
  sortStoreProjectsEarliestFirst,
  storeQuoteDisplayLabel,
} from "../service";

/**
 * Renders quote rows for buyer accounts with multiple users.
 *
 * - `placement="page"`: teammates first, divider, current user last (My Quotes grid).
 * - `placement="menu"`: current user first in DOM so upward menus show yours at the bottom.
 */
export function StoreBuyerQuotePickerItems({
  quotes,
  currentUser,
  renderItem,
  placement = "page",
}) {
  const currentUserId = normalizeStoreUserId(currentUser);
  const { others, own } = partitionStoreProjectsByOwner(quotes, currentUserId);
  const sortedOthers = sortStoreProjectsEarliestFirst(others);
  const sortedOwn = sortStoreProjectsEarliestFirst(own);
  const showDivider = sortedOthers.length > 0 && sortedOwn.length > 0;
  const menuOpensUp = placement === "menu";

  const renderQuote = (project) => {
    const isCoUser =
      currentUserId != null && !isOwnStoreProject(project, currentUserId);
    return renderItem(
      project,
      storeQuoteDisplayLabel(project, currentUserId),
      { isCoUser }
    );
  };

  if (menuOpensUp) {
    return (
      <>
        {sortedOwn.map((project) => renderQuote(project))}
        {showDivider ? <DropdownItem divider /> : null}
        {sortedOthers.map((project) => renderQuote(project))}
      </>
    );
  }

  return (
    <>
      {sortedOthers.map((project) => renderQuote(project))}
      {showDivider ? <DropdownItem divider /> : null}
      {sortedOwn.map((project) => renderQuote(project))}
    </>
  );
}
